import type { JournalFactionData } from "@roll1/shared";
import { NOTE_CLASS } from "../ui/card";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Label } from "../ui/label";
import { useI18n } from "../../i18n";

interface FactionFormProps {
  data: JournalFactionData;
  onChange: (partial: Partial<JournalFactionData>) => void;
  focusedFieldRef: React.MutableRefObject<string | null>;
}

export default function FactionForm({
  data,
  onChange,
  focusedFieldRef,
}: FactionFormProps) {
  const { t } = useI18n();

  const handleFocus = (field: string) => {
    focusedFieldRef.current = field;
  };
  const handleBlur = () => {
    focusedFieldRef.current = null;
  };

  return (
    <div className="space-y-3">
      <div>
        <Label className="text-meta text-muted-foreground">
          {t("journal.form.faction.description")}
        </Label>
        <Textarea
          className="text-ui min-h-[80px]"
          value={data.description}
          onChange={(e) => onChange({ description: e.target.value })}
          onFocus={() => handleFocus("description")}
          onBlur={handleBlur}
        />
      </div>
      <div>
        <Label className="text-meta text-muted-foreground">
          {t("journal.form.faction.attitude")}
        </Label>
        <Input
          className="h-8 text-ui"
          value={data.attitude}
          onChange={(e) => onChange({ attitude: e.target.value })}
          onFocus={() => handleFocus("attitude")}
          onBlur={handleBlur}
        />
      </div>
      <div className={NOTE_CLASS}>
        <Label className="text-meta text-muted-foreground">
          {t("journal.form.faction.secrets")}
          <span className="ml-1 text-warn text-label">
            {t("journal.editor.gmOnly")}
          </span>
        </Label>
        <Textarea
          className="text-ui min-h-[60px]"
          value={data.secrets}
          onChange={(e) => onChange({ secrets: e.target.value })}
          onFocus={() => handleFocus("secrets")}
          onBlur={handleBlur}
        />
      </div>
    </div>
  );
}
